import { AppServices } from '@singularsystems/neo-core';

import { ICatalogueQueryApiClient } from './ApiClients/CatalogueQueryApiClient';
import { IApprovalsQueryApiClient } from './ApiClients/Approvals/ApprovalsQueryApiClient';
import { IIncentiveSchemesQueryApiClient } from './ApiClients/IncentiveSchemesQueryApiClient';
import { IIncentiveGroupsQueryApiClient } from './ApiClients/IncentiveGroupsQueryApiClient';
import { IAwardModuleConfigApiClient } from './ApiClients/Config/AwardModuleConfigApiClient';
import AwardUtils from './Services/AwardUtils';
import OfferTotalsService from './Services/OfferTotalsService';
import { ISurveysApiClient } from './ApiClients/SurveysApiClient';
import { IAnswerQuestionnaireQueryApiClient } from './ApiClients/Questionnaires/AnswerQuestionnaireQueryApiClient';
import { IAnswerQuestionnaireCommandApiClient } from './ApiClients/Questionnaires/AnswerQuestionnaireCommandApiClient';

// Symbols to expose outside of this module
const CommonTypes = {
    ApiClients: {
        ApprovalsQueryApiClient: new AppServices.ServiceIdentifier<IApprovalsQueryApiClient>("Awards.ApiClients.ApprovalsQueryApiClient"),
        CatalogueQueryApiClient: new AppServices.ServiceIdentifier<ICatalogueQueryApiClient>("Awards.ApiClients.CatalogueQueryApiClient"),
        IncentiveSchemesQueryApiClient: new AppServices.ServiceIdentifier<IIncentiveSchemesQueryApiClient>("Awards.ApiClients.IncentiveSchemesQueryApiClient"),
        IncentiveGroupsQueryApiClient: new AppServices.ServiceIdentifier<IIncentiveGroupsQueryApiClient>("Awards.ApiClients.IncentiveGroupsQueryApiClient"),
        AwardModuleConfigApiClient: new AppServices.ServiceIdentifier<IAwardModuleConfigApiClient>("Awards.ApiClients.AwardModuleConfigApiClient"),
        SurveysApiClient: new AppServices.ServiceIdentifier<ISurveysApiClient>("Awards.ApiClients.SurveysApiClient"),
        AnswerQuestionnaireQueryApiClient: new AppServices.ServiceIdentifier<IAnswerQuestionnaireQueryApiClient>("Awards.ApiClients.AnswerQuestionnaireQueryApiClient"),
        AnswerQuestionnaireCommandApiClient: new AppServices.ServiceIdentifier<IAnswerQuestionnaireCommandApiClient>("Awards.ApiClients.AnswerQuestionnaireCommandApiClient"),
    },
    Services: {
        OfferTotalsService: new AppServices.ServiceIdentifier<OfferTotalsService>("Awards.Services.OfferTotalsService"),
        AwardUtils: new AppServices.ServiceIdentifier<AwardUtils>("Awards.Services.AwardUtils")
    },
}

export { CommonTypes as Types }